import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { JWTTokenService } from './jwt.token.service';
import { ApiService } from './api.service';
import { getAuth } from 'firebase/auth';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
const httpOptions = {
  headers: new HttpHeaders({
    'Accept': 'application/json'
  })
} 

const httpOptionsWithOutToken = {
  headers: new HttpHeaders({
    'Accept': 'application/json',
    'skip': 'true'
  })
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public FullName    = new BehaviorSubject<any>(null);
  public PhoneNumber    = new BehaviorSubject<any>(null);
  public Picture    = new BehaviorSubject<any>(null);
  private Role    = new BehaviorSubject<any>(null);
  public profileCompletion = new BehaviorSubject<any>('');
  public unreadNotifications = new BehaviorSubject<any>('');
  public unreadMessages = new BehaviorSubject<any>('');
  baseURL: string = environment.baseURL;
  EmployeeSignUpURL: string =  this.baseURL + 'employee';
  EmployerSignUpURL: string =  this.baseURL + 'employer';
  LoginURL: string =  this.baseURL + 'users/check_user';
  ChangeAuthMethodURL: string =  this.baseURL + 'users/change_to_email_auth';
  EmailVerificationURL: string =  this.baseURL + 'users/verify/';
  user: any;
  constructor(private http: HttpClient, public jwtService: JWTTokenService,public ApiService: ApiService,private router : Router,@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      const storedName = localStorage.getItem('GPFullName');
      if (storedName) {
        this.FullName.next(storedName);
      }

      const storedPhoneNumber = localStorage.getItem('GPPhoneNumber');
      if (storedPhoneNumber) {
        this.PhoneNumber.next(storedPhoneNumber);
      }

      const storedPicture = localStorage.getItem('GPPicture');
      if (storedPicture) {
        this.Picture.next(storedPicture);
      }

      const storedRole = localStorage.getItem('GPROLE');
      if (storedRole) {
        this.Role.next(storedRole);
      }
    }
   }

  EmployeeSignUp(credentials: any) {
    return this.http.post<any>(this.EmployeeSignUpURL, credentials, httpOptions);
  }

  EmployerSignUp(credentials: any) {
    return this.http.post<any>(this.EmployerSignUpURL, credentials, httpOptions);
  }

  emailVerification(token: string) {
    return this.http.get<any>(this.EmailVerificationURL + token, httpOptionsWithOutToken);
  }

  changeAuthMethod() {
    return this.http.get<any>(this.ChangeAuthMethodURL, httpOptions);
  }

  checkUser(credentials: any) {
    return this.http.post<any>(this.LoginURL, credentials, httpOptionsWithOutToken);
  }
  
  logout(){
    const auth = getAuth();
    if (typeof window !== 'undefined') {
      localStorage.removeItem('GPROLE');
      localStorage.removeItem('GProToken');
      localStorage.removeItem('GPSTATE');
      localStorage.removeItem('GPFullName');
      localStorage.removeItem('GPPhoneNumber');
      localStorage.removeItem('GPPicture');
    }
    this.ApiService.isAuthenticatedSrc.next(false);
    auth.signOut().then(function() {
    }, function(error) {
      console.error('Sign Out Error', error);
    });
    this.router.navigate(['/auth/login']);
  }


  get currentFullName() 
  {
      return this.FullName.asObservable();
  }
  get currentPhoneNumber() 
  {
      return this.PhoneNumber.asObservable();
  }
  get currentPicture() 
  {
      return this.Picture.asObservable();
  }
  get currentRole() 
  {
      return this.Role.asObservable();
  }
  get currentNotification() 
  {
      return this.unreadNotifications.asObservable();
  }
  get currentMessage() 
  {
      return this.unreadMessages.asObservable();
  }
  get currentprofileCompletion() 
  {
      return this.profileCompletion.asObservable();
  }

}
